/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { PaymentService } from '../services/v3/payment.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private paymentService: PaymentService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.paymentService.authToken) {
      const modifiedRequest = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.paymentService.authToken}`,
        },
      });

      return next.handle(modifiedRequest);
    }

    return next.handle(request);
  }
}
